import { Box, BoxProps } from 'roo-ui/components';
import { useBookingListContext } from '../contextProvider/BookingListContextProvider';
import LoadingBlock from 'components/LoadingBlock';
import LoadMoreButton from './LoadMoreButton';
import NoUpcomingBookings from '../NoUpcomingBookings';
import { UpcomingBookingCard, PastBookingCard, CancelledBookingCard } from '../Card';

const BookingList = (props: BoxProps) => {
  const { filter, loading, bookings, hasMore, loadMore } = useBookingListContext();

  let BookingCard = UpcomingBookingCard;

  if (filter === 'past') {
    BookingCard = PastBookingCard;
  } else if (filter === 'cancelled') {
    BookingCard = CancelledBookingCard;
  }

  const bookingCards = bookings.map((booking) => <BookingCard booking={booking} key={`booking-${booking.reference}`} />);

  return (
    <Box data-testid={`${filter}-booking-list`} {...props}>
      <Box>{bookingCards}</Box>
      {!loading && bookingCards.length === 0 && filter === 'upcoming' && <NoUpcomingBookings />}
      {loading && <LoadingBlock />}
      {!loading && hasMore && <LoadMoreButton onClick={loadMore} loading={loading} />}
    </Box>
  );
};

export default BookingList;
